import styled from '@emotion/styled'

const StyledMenu = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 24px;
  height: 64px;
  position: relative;
  .float-menu-btn {
    border-radius: 4px;
    cursor: pointer;
    padding: 6px;
    margin-right: 40px;
    background: var(--ow-color-primary-700);
    &:hover {
      background: var(--ow-color-primary-600);
    }
    &:active {
      background: var(--ow-color-primary-800);
    }
  }
`
const StyledMenuContent = styled.div`
  width: ${({ style }) => {
    return style.width
  }};
  display: flex;
  align-items: center;
  // 导航列表可视部分
  .menu-content {
    overflow: auto;
    display: flex;
    align-items: center;
    height: 80px;
    position: relative;
    top: 2px;

    &::-webkit-scrollbar {
      display: none;
    }
    scroll-behavior: smooth;
  }
  // 上一页/下一页 按钮
  .scroll-btn {
    padding: 24px 12px;
    cursor: pointer;
    position: relative;
  }
  .left-arrow-btn {
    border-right: 1px solid var(--ow-color-primary-600);
    box-shadow: 12px 0 24px 0 rgba(0, 0, 0, 0.15);
  }
  .right-arrow-btn {
    border-left: 1px solid var(--ow-color-primary-600);
    box-shadow: -12px 0 24px 0 rgba(0, 0, 0, 0.15);
  }
`
const StyledMenuNavItem = styled.div`
  .nav-name {
    font-weight: 500;
    font-size: 16px;
    padding: 8px 24px;
    cursor: pointer;
    white-space: nowrap;
  }
  .nav-item-active {
    border-radius: 3px;
  }
`

const StyledMenuFloatContent = styled.div`
  width: 100%;
  position: absolute;
  top: 64px;
  left: 0;
  z-index: 101;
  background: var(--ow-color-white-100);
  box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.08),
    0 16px 24px 2px rgba(0, 0, 0, 0.04), 0 6px 30px 5px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  padding: 8px;
  max-height: 406px;
  overflow: auto;
`
const StyledMenuFloatNavItem = styled.div`
  .nav-name {
    color: rgba(0, 0, 0, 0.9);
    font-size: var(--font-size-sm);
    padding: 11px 12px;
    cursor: pointer;
    border-radius: 4px;
    &:not(.nav-item-active):hover {
      background: var(--ow-color-neutral-100);
    }
  }
  .nav-item-active {
    color: var(--ow-color-white-100);
    background: var(--ow-color-primary-700);
  }
`

export {
  StyledMenu,
  StyledMenuContent,
  StyledMenuNavItem,
  StyledMenuFloatContent,
  StyledMenuFloatNavItem,
}
